<template>
  <div style="min-height:70vh">
    <div class="d-flex px-5">
      <h3 class="my-4 m-auto">Live VR Classroom {{$t('list_of_class')}}({{(this.$route.name === 'VR_classroom' ? $t('using_records') : $t('start_new_course'))}})</h3>
      <img class="back-icon pointer my-4" @click="previousPage" style="height:20px" src="../../../assets/image/icon/close_lesson.png" />
    </div>
    <!-- 沒有班級 -->
    <div v-for="(item ,index) in list" :key="index" class="list-box my-2">
      <div class="menu-box d-flex justify-content-between my-4" @click="goPage(item.id)" >
        <h3 class="my-auto py-2">{{item.name}}</h3>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../../store/api.js'
export default {

  name: 'ClassroomList',

  data () {
    return {
      list: [],
      pageIndex: 1,
      pageCount: 0
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    goPage (id) {
      if (this.$route.name === 'VR_classroom') {
        this.$router.push({name: 'VR_student', params: { id: id }})
      } else {
        this.$router.push({name: 'VR_record', params: { id: id }})
      }
    },
    async getList (page) {
      page = page || 1
      const { data } = await api.get('/GroupMgr/TeachingGroups', { params: { pageIndex: page } })
      this.list = data.data
      this.pageIndex = data.pageIndex
      this.pageCount = data.pageCount
    },
    previousPage () {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/style/color.scss";
  .list-box {
    width: 60%;
    margin: auto;
  }
  .menu-box {
    cursor: pointer;
    text-align: left;
    background-color: #fff;
    border-radius: 10px;
    border: 1.5px solid #6666;
    margin: 10px auto;
    padding: 10px 20px;
    p {
      margin: 0;
    }
      &:hover {
      box-shadow:0px 0px 8px #a1a1a1;
    }
  }
</style>


// WEBPACK FOOTER //
// ClassroomList.vue?5f57347e